<template>
  <div class="dashboard-container">
    <!-- 主标题卡片 -->
    <!-- div class="header-card" shadow="never">
      <div class="header-content">
        <span class="header-title">全局产品看板</span>
      </div>
    </div-->

    <!-- 产品卡片容器 -->
    <div class="cards-container">
      <el-card v-for="(item, index) in cardData" :key="index" class="product-card" shadow="hover"
        :style="{ borderLeft: `4px solid ${getStatusColor(index)}` }">
        <template #header>
          <div class="card-header">
            <div class="title-container">
              <span class="card-title">{{ item.title }}</span>
            </div>
            <span class="card-tag" v-if="item.state === '3'" :style="{ color: getStatusColor(index) }">未完成</span>
            <span class="card-tag" v-else :style="{ color: getStatusColor(index) }">{{ item.state }}</span>
          </div>
        </template>

        <div class="card-content">
          <!-- 新增开发活跃度统计标题 -->
          <div class="sprint-active-title">
            <div class="info-item">
              <span title="在建/总数">Sprints：{{ item.sprint }}</span>
            </div>&nbsp;
            <div class="info-item">
              <span>PO：{{ item.pO }}</span>
            </div>&nbsp;
            <div class="info-item">
              <span>团队：{{ item.teamCnt }}</span>
            </div>&nbsp;
            <div class="info-item">
              <span>动态：{{ item.productDynamicCnt }}</span>
            </div>&nbsp;
            <div class="info-item">
              <span>日志：{{ item.productLogCnt }}</span>
            </div>
          </div>
          <!-- 表格区域-->
          <div class="sprint-table" style="margin-top: 10px;">
            <table>
              <thead>
                <tr>
                  <th>Sprint</th>
                  <th style="width: 8%;">动态</th>
                  <th style="width: 8%;">日志</th>
                  <th style="width: 8%;">会议</th>
                  <th style="width: 8%;">审视</th>
                  <th>团队</th>
                  <th style="width: 12%;">SM</th>
                  <th style="width: 8%;">工时</th>
                </tr>
              </thead>
              <tbody>
                <!-- 如果sprint等于null就显示暂无数据 -->
                <tr v-if="item.sprintInfos.length === 0">
                  <td colspan="8" style="text-align: center; font-size: 11px;">暂无数据</td>
                </tr>
                <!-- 否则正常显示数据 -->
                <tr v-for="(sprintInfo, idx) in item.sprintInfos" :key="idx">
                  <td>{{ sprintInfo.sprintName }}</td>
                  <td>{{ sprintInfo.dynamicCnt }}</td>
                  <td>{{ sprintInfo.sprintLogCnt }}</td>
                  <td>{{ sprintInfo.meetingCnt }}</td>
                  <td>{{ sprintInfo.surveyCnt }}</td>
                  <td>{{ sprintInfo.teamName }}</td>
                  <td>{{ sprintInfo.sM }}</td>
                  <td>{{ sprintInfo.completeTime }}/{{ sprintInfo.estimatedTime }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- 项目周期 -->
          <div class="project-cycle">
            <span class="label">开发周期：</span>
            <span class="value">{{ item.projectCycle }}</span>
            &nbsp;|&nbsp;
            <span class="label">最后更新：</span>
            <span class="value">{{ item.updateTime }}</span>
          </div>
        </div>
      </el-card>
    </div>
    <!-- 分页组件 -->
    <div class="pagination-container" v-if="page" style="margin-top: 20px;">
      <el-pagination :total="page.total" :page-size="page.pageSize" :current-page.sync="page.currentPage"
        layout="total, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import api from '@/api/global/productGlobal.js'
export default {
  name: 'productGlobalList',
  data() {
    return {
      listLoading: false,
      listData: [],
      page: {  // 添加 page 对象
        currentPage: 1,
        pageSize: 6,
        total: 0
      },
    }
  },
  computed: {
    cardData() {
      return this.listData.map(item => ({
        title: item.productName,
        updateTime: this.formatDateTime(item.updateTime),
        state: item.state === '3' ? '未完成' : item.state || '-',
        sprint: `${item.activeSprintCnt || 0}/${item.totalSprintCnt || 0}`,
        pO: item.pO,
        productDynamicCnt: item.productDynamicCnt || '0',
        productLogCnt: item.productLogCnt || '0',
        teamCnt: item.teamCnt || '0',
        projectCycle: `${this.formatDate(item.startTime)} 至 ${this.formatDate(item.endTime)}`,
        sprintInfos: (item.sprintInfos || []).map(sprint => ({
          sprintName: sprint.sprintName || '-',
          dynamicCnt: sprint.dynamicCnt || '0',
          sprintLogCnt: sprint.sprintLogCnt || '0',
          meetingCnt: sprint.meetingCnt || item.meetingCnt || '0',
          surveyCnt: sprint.surveyCnt || item.surveyCnt || '0',
          teamName: sprint.teamName || item.teamName || '-',
          sM: sprint.sM || '-',
          completeTime: sprint.completeTime || '-',
          estimatedTime: sprint.estimatedTime || '-',
        }))
      }));
    }
  },
  methods: {
    fetchProductData() {
      if (!this.page) return;

      this.listLoading = true;
      api.getProductList({
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }, response => {
        this.listData = response.data.records || [];
        this.page.total = response.data.total || 0;
       // this.$utils.msg.success(response.msg);
        this.listLoading = false;
      },
        (error) => {
          this.listLoading = false;
          this.$utils.msg.error(error.msg);
          console.error('API Error:', error);
        },
        (exception) => {
          this.listLoading = false;
          this.$utils.msg.error(exception.msg);
          console.error('API Exception:', exception);
        })
    },
    //格式化日期
    formatDate(dateString) {
      if (!dateString) return '未设置'
      const date = new Date(dateString)
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
    },
    // 格式化日期（精确到时分秒）
    formatDateTime(dateString) {
      if (!dateString) return '未设置';
      const date = new Date(dateString);

      // 获取年月日
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      // 获取时分秒
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');

      // 返回完整格式：YYYY-MM-DD HH:mm:ss
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 获取卡片状态颜色
    getStatusColor(index) {
      const colors = ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399', '#9c27b0'];
      return colors[index % colors.length];
    },

    // 获取卡片状态类型
    getStatusType(index) {
      const types = ['primary', 'success', 'warning', 'danger', 'info', ''];
      return types[index % types.length];
    },

    // 计算Sprint进度百分比
    getSprintProgress(sprint) {
      const [current, total] = sprint.split('/').map(Number);
      return total > 0 ? Math.round((current / total) * 100) : 0;
    },

    // 计算工日消耗进度百分比
    getWorkTimeProgress(workTime) {
      const [used, total] = workTime.split('/').map(Number);
      return total > 0 ? Math.round((used / total) * 100) : 0;
    },
    // 处理页码变化
    handleCurrentChange(pageNum) {
      this.page.currentPage = pageNum;
      this.fetchProductData();
    },

    // 处理每页显示数量变化
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.currentPage = 1; // 切换每页数量时重置为第一页
      this.fetchProductData();
    }
  },
  mounted() {
    this.fetchProductData();
  }
};
</script>

<style lang="scss" scoped>
@import '~common/custom/css/productGlobal.scss';
</style>